/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type JiraIntegrationSection_project = {
    readonly id: string;
    readonly name: string | null;
    readonly jiraCloudProjectSettings: {
        readonly syncRemaining: boolean | null;
        readonly cutoffDate: string | null;
        readonly isSyncDone: boolean | null;
        readonly syncSprints: boolean | null;
        readonly estimateInTime: boolean | null;
        readonly estimateInPointsCustomFieldName: string | null;
        readonly mapJiraSubTasksToToDo: boolean | null;
        readonly mapJiraVersionsToPhases: boolean | null;
    } | null;
    readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
    readonly jiraCloudProject: {
        readonly id: string;
        readonly name: string | null;
        readonly style: string | null;
    } | null;
    readonly jiraErrors: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly createdAt: string | null;
                readonly errorCode: string | null;
                readonly task: {
                    readonly id: string;
                    readonly companyTaskId: number | null;
                } | null;
                readonly timeRegId: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly tasks: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly parentTaskId: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly useTaskHierarchy: boolean | null;
    readonly status: PROJECT_STATUS | null;
    readonly " $refType": "JiraIntegrationSection_project";
};
export type JiraIntegrationSection_project$data = JiraIntegrationSection_project;
export type JiraIntegrationSection_project$key = {
    readonly " $data"?: JiraIntegrationSection_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"JiraIntegrationSection_project">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JiraIntegrationSection_project",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraCloudProjectSettingsType",
      "kind": "LinkedField",
      "name": "jiraCloudProjectSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "syncRemaining",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cutoffDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSyncDone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "syncSprints",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimateInTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimateInPointsCustomFieldName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mapJiraSubTasksToToDo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mapJiraVersionsToPhases",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraCloudEpicIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraCloudProjectType",
      "kind": "LinkedField",
      "name": "jiraCloudProject",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraErrorTypeConnection",
      "kind": "LinkedField",
      "name": "jiraErrors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraErrorTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "JiraErrorType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "errorCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "task",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "companyTaskId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "timeRegId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100000
        }
      ],
      "concreteType": "TaskTypeConnection",
      "kind": "LinkedField",
      "name": "tasks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "parentTaskId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "tasks(first:100000)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useTaskHierarchy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
})();
(node as any).hash = '025f9683157bc6f980329c564412efc1';
export default node;
